const domain = 'api.econsult.health';
const ROOT_URL = `https://${domain}`;

export const productionConfig = {
  SUMMARISER: {
    HOST: `${ROOT_URL}/summariser`,
    WEBSOCKET: `wss://${domain}/summariser`,
  },
  AUTH: {
    HOST: `${ROOT_URL}/auth`,
  },
  USER_MANAGEMENT: {
    HOST: `${ROOT_URL}/usermanagement`,
  },
  CUSTOMISATION: {
    HOST: `${ROOT_URL}/customisation`,
  },
  SMART_INBOX: {
    HOST: 'https://inbox.econsult.health/workflow/home',
  },
  E_LITE: {
    HOST: 'https://elite.econsult.health',
  },
  SETTINGS: {
    HOST: 'https://settings.econsult.health',
  },
  REPORTING: {
    HOST: 'https://inbox.econsult.health/workflow/reports',
  },
  INTERCOM: {
    ENABLED: true,
    APP_ID: 'f9w7aj87',
  },
  FRESHPAINT: {
    ENABLED: true,
    ID: '18edd0e4-aa4a-4d9a-bfd6-9c110e3fbdf3',
  },
  STRIPE: {
    PUBLISHABLE_KEY:
      'pk_live_51Rt5Xo2UCj1X3z68UZPPNKt9O1B4hWYFsINIep9QQzMbmOcVOHS6t9n8iZSHNkGTHw5Qma7QXRvDcgpZTcSegR7k00kUfxwLWy',
  },
};
